import React, { useState, useEffect } from 'react'
import { Panel, Row, Col } from 'rsuite'
import InputForm from '../../../components/forms/input/InputForm'
import InputSelectForm from '../../../components/forms/input/InputSelectForm'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { cloneDeep } from 'lodash-es'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

export default function EditFormDescriptionWidget({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [datas, setDatas] = useState(_schema?.values || [])
  const [deleteIds, setDeleteIds] = useState([])

  const descValues = 'descSettingValues'
  const descDelIds = 'descDelIds'

  // useEffect(() => {
  //   setDatas(_schema.values || [])
  // }, [_schema])
  //console.log(_schema)

  const onAdd = () => {
    let data = cloneDeep(datas || [])
    data.push({
      id: null,
      msgType: '1',
      msg: null,
    })
    setDatas(data)
    setValue(descValues, data)
  }

  const onRemove = (item, index) => {
    if (item.id) {
      var delIds = [...deleteIds, item.id]
      setDeleteIds(delIds)
      setValue(descDelIds, delIds)
    }

    let data = cloneDeep(datas || [])
    data.splice(index, 1)
    setDatas(data)
    setValue(descValues, data)
  }

  return (
    <>
      {schema && (
        <>
          <Row>
            <Col>{schema.header}</Col>
          </Row>
          <Controller
            key={descDelIds}
            name={descDelIds}
            control={control}
            // rules={isValidators(schema.validators)}
            defaultValue={deleteIds}
            value={deleteIds}
          />
          <Controller
            key={descValues}
            name={descValues}
            control={control}
            // rules={isValidators(schema.validators)}
            defaultValue={datas}
            value={datas}
          />

          {datas.map((item, index) => {
            return (
              <Panel bordered style={{ marginBottom: 10 }}>
                <div>
                  {schema.type && (
                    <InputSelectForm
                      schema={schema.type}
                      name={`${schema.type.name}_${index}`}
                      searchable={false}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      value={item.msgType}
                      onChange={(value) => {
                        //let data = cloneDeep(datas || [])
                        let data = datas
                        data[index].msgType = value
                        setDatas(data)
                      }}
                    />
                  )}

                  {schema.message && (
                    <InputForm
                      rows={4}
                      componentClass="textarea"
                      schema={schema.message}
                      name={`${schema.message.name}_${index}`}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      value={item.msg}
                      onChange={(value) => {
                        //let data = cloneDeep(datas || [])
                        let data = datas
                        data[index].msg = value
                        setDatas(data)
                      }}
                    />
                  )}
                  <CancelButton
                    style={{
                      marginTop: 10,
                      // marginBottom: 10,
                    }}
                    icon="trash-o"
                    children={`ลบ`}
                    onClick={() => {
                      onRemove(item, index)
                    }}
                  />
                </div>
              </Panel>
            )
          })}

          <SaveButton
            style={{
              marginTop: 10,
              marginBottom: 10,
            }}
            icon="plus"
            children={`เพิ่ม ${schema.header}`}
            onClick={onAdd}
          />
        </>
      )}
    </>
  )
}
